export default "__VITE_ASSET__BSLPG$ts__"